import { usePlanningFormTranslation } from '@libs/utils/translations'
import RestTypes from '@spa/constants/RestTypes'
import { useDiffToReadableDaysWithHalf } from '@spa/services/utils'
import type { FC } from 'react'

import type { RestFormData } from '../../../hooks/useRestRHF'

import styles from './RestSummary.module.css'

const IS_MORNING = 'morning'

type Props = {
  restType: string
} & Partial<RestFormData>

const RestSummary: FC<Props> = ({ restType, ...other }) => {
  const { t } = usePlanningFormTranslation()
  const starsAt = other?.dateRange?.start?.date
  const endsAt = other?.dateRange?.end.date
  const startHalfDay = other?.dateRange?.start.halfDay
  const endHalfDay = other?.dateRange?.end.halfDay

  const start =
    startHalfDay === IS_MORNING
      ? t('restForm.start', { date: starsAt })
      : t('restForm.end', { date: starsAt })

  const end =
    endHalfDay === IS_MORNING
      ? t('restForm.start', { date: endsAt })
      : t('restForm.end', { date: endsAt })

  const duration = useDiffToReadableDaysWithHalf(
    starsAt,
    endsAt,
    startHalfDay,
    endHalfDay
  )
  const restItem = RestTypes.get(restType)

  return (
    <div
      className={styles.HeadContainer}
      style={{
        backgroundColor: restItem?.background_color
      }}
    >
      <span className={styles.HeadTitle}>
        {t(`common.app:models.rests.${restItem?.id}.name`)}
      </span>
      <span className={styles.HeadInfos}>
        {t('restForm.restSummary', { start, end, duration })}
      </span>
    </div>
  )
}

export default RestSummary
